import { find } from 'lodash';
import { useMemo } from 'react';

import { useEndpointsWithInboxes } from './useEndpointsWithInboxes';

const useGetEndpointWithInbox = ({ endpointId }) => {
  const { endpoints } = useEndpointsWithInboxes();

  const endpoint = useMemo(() => {
    return find(endpoints, ({ id }) => id === endpointId);
  }, [endpointId, endpoints]);

  return { address: endpoint?.address ?? '', inboxName: endpoint?.inboxes ?? '' };
};

export default useGetEndpointWithInbox;
